"use client";

import { usePathname } from "next/navigation";
import { Suspense, useEffect } from "react";
import { pageview } from "@/shared/analytics/meta-pixel";

function MetaPixelTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      pageview();
    }
  }, [pathname]);

  return null;
}

export function MetaPixelPageview() {
  return (
    <Suspense fallback={null}>
      <MetaPixelTracker />
    </Suspense>
  );
}
